import 'bootstrap-daterangepicker/daterangepicker.css';
import { debounce } from 'lodash';
import moment from 'moment';
import { useCallback, useEffect, useMemo, useState } from 'react';
import { Alert, OverlayTrigger, Popover, Spinner } from 'react-bootstrap';
import 'react-image-lightbox/style.css';
import { useLocation } from 'react-router-dom';
import Select from '../../../components/textFields/AppSelect'
import { components } from 'react-select';
import { toast } from 'react-toastify';
import { KTSVG } from '../../../_metronic/helpers';
import CurrencyComp from '../../../components/currencyComponent/CurrencyComp';
import DateRangeComp from '../../../components/dateComponent/DateRangeComp';
import DateTimeComp from '../../../components/dateComponent/DateTimeComp';
import { LoadingComponent } from '../../../components/loadingComponent/LoadingComponent';
import NoRecordFound from '../../../components/noRecord/NoRecordFound';
import Pagination from '../../../components/pagination/Pagination';
import RefreshComponent from '../../../components/refreshComponent/RefreshComponent';
import SearchBarComponent from '../../../components/searchBar/SearchBarComponent';
import TableHeading from '../../../components/tableHeading/TableHeading';
import TableSettingMenu from '../../../components/tableHeading/TableSettingMenu';
import SearchSelect from '../../../components/textFields/SearchSelect';
import TextField from '../../../components/textFields/TextField';
import { constraintConfig } from '../../../constraintConfig';
import { selectAuth } from '../../../features/authSlice';
import { useAppSelector } from '../../../hooks';
import { useExpenseCategoryLookupQuery, useGetAllDepartmentByManagerQuery, useGetAllManagersLookupQuery, useGetAllUsersLocationQuery, useGetReportUsersByManagerIdQuery, useGetUsersByManagerIdQuery } from '../../../services/GeneralApi';
import { useGetExpenseCatagoryBudgetReportQuery } from '../../../services/ReportAndAnalyticsApi';
import useColumnVisibility from '../../customHooks/useColumnVisibility';
import labelKey from "../../localization/label.json";
import tosterKey from "../../localization/toster.json";
import { myReportPaths, queryReportPaths, teamReportPaths } from './ReportPaths';

const { Option } = components;
type Option = {
    value: string;
    label: string;
};

// Custom Option component to add checkboxes
const CheckboxOption = (props: any) => {
    return (
        <Option {...props}>
            <div className='d-flex align-items-center gap-2 ss-multi-check-option w-100 cursor-pointer'>
                <input
                    type='checkbox'
                    className='form-check-input ss-multi-check-option__input m-0 cursor-pointer'
                    checked={!!props.isSelected}
                    onChange={() => null}
                    tabIndex={-1}
                />
                <label className='ss-multi-check-option__label mb-0 cursor-pointer' title={props.label}>
                    {props.label}
                </label>
            </div>
        </Option>
    );
};

const CategoryBudgetReport = () => {
    const { hiddenColumns, handleToggleColumn } = useColumnVisibility({ pageName: 'categoryBudgetReport' });
    const location = useLocation()
    const currentDate = moment().format('MM/DD/YYYY');
    const sevenDaysAgo = moment().subtract(6, 'days').format('MM/DD/YYYY');
    const [filterByCategory, setFilterByCategory] = useState("0");
    const [filterByStartDate, setFilterByStartDate] = useState(sevenDaysAgo);
    const [filterByEndDate, setFilterByEndDate] = useState(currentDate);
    const [searchStr, setSearchStr] = useState(''); // debounce search
    const [immediateSearchStr, setImmediateSearchStr] = useState('');
    const [page, setPage] = useState(1)
    const [pageSize, setPageSize] = useState(10);
    const [sortBy, setSortBy] = useState("");
    const [sortOrder, setSortOrder] = useState("desc");
    const [filterByCategoryIds, setFilterByCategoryIds] = useState<string[]>([]);
    const [filterByLocationIds, setFilterByLocationIds] = useState<string[]>([]);
    const [filterByUserIds, setFilterByUserIds] = useState<string[]>([]);
    const [filterByManager, setFilterByManager] = useState(0);
    const [filterByTimePeriod, setFilterByTimePeriod] = useState('');

    const [selectedCategoryIds, setSelectedCategoryIds] = useState<Option[]>([]);
    const [selectedLocationIds, setSelectedLocationIds] = useState<Option[]>([]);
    const [selectedUserIds, setSelectedUserIds] = useState<Option[]>([]);

    const [localFilterByStartDate, setLocalFilterByStartDate] = useState(sevenDaysAgo);
    const [localFilterByEndDate, setLocalFilterByEndDate] = useState(currentDate);
    const [localFilterByCategory, setLocalFilterByCategory] = useState("0");
    const [localFilterByCategoryIds, setLocalFilterByCategoryIds] = useState<string[]>([]);
    const [localFilterByLocationIds, setLocalFilterByLocationIds] = useState<string[]>([]);
    const [localFilterByUserIds, setLocalFilterByUserIds] = useState<string[]>([]);
    const [localFilterByTimePeriod, setLocalFilterByTimePeriod] = useState("");

    const [isApplyingFilters, setIsApplyingFilters] = useState(false);
    const [showFilters, setShowFilters] = useState(false);

    const myReportpath = myReportPaths.includes(location.pathname);
    const queryFeportPath = queryReportPaths.includes(location.pathname);
    const teamFeportPath = teamReportPaths.includes(location.pathname);


    const { userAccountID, roleID, reportPermision } = useAppSelector(selectAuth)
    const { data: expenseCategory } = useExpenseCategoryLookupQuery('')
    const { data: getAllDepByManager, refetch: getAllDepByManagerRefetch } = useGetAllDepartmentByManagerQuery({ reportPermission: queryFeportPath ? reportPermision : false })
    const { data: getAllUsersLocation, refetch: getAllUsersLocationRefetch } = useGetAllUsersLocationQuery({ reportPermission: queryFeportPath ? reportPermision : false })
    const { data: getAllManagers } = useGetAllManagersLookupQuery('')
    const { data: getUserByManager, refetch: userByManagerRefetch } = useGetReportUsersByManagerIdQuery({ managerId: filterByManager })

    useEffect(() => {
        if (filterByManager) {
            userByManagerRefetch()
        }
        userByManagerRefetch()
        getAllDepByManagerRefetch()
        getAllUsersLocationRefetch()
    }, [filterByManager])





    const { data, isFetching: isLoading, refetch, isSuccess } = useGetExpenseCatagoryBudgetReportQuery(
        {
            reportFilter: myReportpath ? 0 : queryFeportPath ? 2 : 1,
            startDate: filterByStartDate,
            endDate: filterByEndDate,
            sortBy: sortBy,
            sortOrder: sortOrder,
            pageNumber: page,
            pageSize: pageSize,
            searchstr: searchStr,
            userIds: filterByUserIds.length > 0 ? filterByUserIds : null,
            categoryIds: filterByCategoryIds.length > 0 ? filterByCategoryIds : null,
            timePeriod: filterByTimePeriod
        })

    const categoryIdsOptions: Option[] = expenseCategory?.result?.map((category: any) => ({
        value: category.id,
        label: category.value,
    }));

    const handleCategoryIdsChange = (selected: Option[]) => {
        setSelectedCategoryIds(selected || []);
        setLocalFilterByCategoryIds(selected ? selected.map((dept) => dept.value) : []);
    };

    const locationOptions: Option[] = getAllUsersLocation?.result?.map((location: any) => ({
        value: location.id,
        label: location.value,
    }));

    const handleLocationChange = (selected: Option[]) => {
        setSelectedLocationIds(selected || []);
        setLocalFilterByLocationIds(selected ? selected.map((location) => location.value) : []);
    };

    const handleManagerChange = (selectedOption: any) => {
        setFilterByManager(selectedOption.value);
    };
    const handleTimePeriodChange = (selectedOption: any) => {
        setLocalFilterByTimePeriod(selectedOption.value);
        setLocalFilterByStartDate('');
        setLocalFilterByEndDate('');
    };

    const userIdsOptions: Option[] = getUserByManager?.result.map((userByManager: any) => ({
        value: userByManager.id,
        label: userByManager.value,
    }));

    const handleUserIdsChange = (selected: Option[]) => {
        setSelectedUserIds(selected || []);
        setLocalFilterByUserIds(selected ? selected.map((userByManager) => userByManager.value) : []);
    };

    // Helper to build CustomMultiValue showing 1 chip + "+X more" popover trigger
    const createCustomMultiValue = (
        title: string,
        selectedList: Array<{ value: any; label: string }>,
        onRemove: (val: any) => void,
        onClear: () => void,
        popoverId: string
    ) => {
        return (props: any) => {
            const { index } = props
            if (index < 1) {
                return <components.MultiValue {...props} />
            }
            if (index === 1) {
                const remainingCount = selectedList.length - 1
                return (
                    <OverlayTrigger
                        trigger='click'
                        placement='bottom'
                        rootClose
                        overlay={
                            <Popover id={popoverId} className='ss-selected-users-popover'>
                                <Popover.Header className='d-flex align-items-center justify-content-between fs-7 fw-bold py-2 px-3'>
                                    <span>
                                        {title} ({selectedList.length})
                                    </span>
                                    <span
                                        className='text-danger fs-8 fw-semibold cursor-pointer'
                                        onClick={(e) => {
                                            e.stopPropagation()
                                            e.preventDefault()
                                            onClear()
                                        }}
                                    >
                                        Clear All
                                    </span>
                                </Popover.Header>
                                <Popover.Body className='p-2'>
                                    <div className='d-flex flex-column gap-1 ss-popover-users-list'>
                                        {selectedList.map((opt) => (
                                            <div
                                                key={String(opt.value)}
                                                className='d-flex align-items-center justify-content-between gap-2 px-2 py-1 rounded ss-popover-user-item'
                                            >
                                                <span className='fs-8 text-truncate' title={opt.label}>
                                                    {opt.label}
                                                </span>
                                                <span
                                                    className='cursor-pointer text-muted hover-danger fs-7 ss-popover-remove-btn'
                                                    title='Remove'
                                                    onClick={(e) => {
                                                        e.stopPropagation()
                                                        e.preventDefault()
                                                        onRemove(opt.value)
                                                    }}
                                                >
                                                    ✕
                                                </span>
                                            </div>
                                        ))}
                                    </div>
                                </Popover.Body>
                            </Popover>
                        }
                    >
                        <span
                            className='badge badge-light-primary fw-bold cursor-pointer ss-show-more-badge ms-1'
                            title={`Click to view all ${title.toLowerCase()}`}
                            onClick={(e) => {
                                e.stopPropagation()
                                e.preventDefault()
                            }}
                            onMouseDown={(e) => {
                                e.stopPropagation()
                                e.preventDefault()
                            }}
                        >
                            +{remainingCount} more
                        </span>
                    </OverlayTrigger>
                )
            }
            return null
        }
    }

    const CategoryMultiValue = useMemo(
        () =>
            createCustomMultiValue(
                'Selected Categories',
                selectedCategoryIds,
                (val) => {
                    const updated = selectedCategoryIds.filter((item) => item.value !== val)
                    handleCategoryIdsChange(updated)
                },
                () => handleCategoryIdsChange([]),
                'selected-categories-popover-budget'
            ),
        [selectedCategoryIds]
    )

    const UsersMultiValue = useMemo(
        () =>
            createCustomMultiValue(
                'Selected Users',
                selectedUserIds,
                (val) => {
                    const updated = selectedUserIds.filter((item) => item.value !== val)
                    handleUserIdsChange(updated)
                },
                () => handleUserIdsChange([]),
                'selected-users-popover-budget'
            ),
        [selectedUserIds]
    )

    const handleCategoryChange = (selectedOption: any) => {
        setLocalFilterByCategory(selectedOption.value);
    };
    const handleDateRangeChange = (event: any, picker: any) => {
        const startDateFormatted = moment(picker.startDate).format('MM-DD-YYYY');
        const endDateFormatted = moment(picker.endDate).format('MM-DD-YYYY');

        setLocalFilterByStartDate(startDateFormatted);
        setLocalFilterByEndDate(endDateFormatted);
        setLocalFilterByTimePeriod('')
    };
    const handleCancelDateSelection = (event: any, picker: any) => {
        // Reset the state to empty strings
        setFilterByStartDate("");
        setFilterByEndDate("");
        setLocalFilterByStartDate("");
        setLocalFilterByEndDate("");
    };
    const applyFilters = () => {
        setIsApplyingFilters(true);
        setFilterByStartDate(localFilterByStartDate);
        setFilterByEndDate(localFilterByEndDate);
        setFilterByCategory(localFilterByCategory);
        setFilterByCategoryIds(localFilterByCategoryIds)
        setFilterByLocationIds(localFilterByLocationIds)
        setFilterByUserIds(localFilterByUserIds)
        setFilterByTimePeriod(localFilterByTimePeriod);
        setPage(1)
    };
    const resetFilters = () => {
        setFilterByStartDate(sevenDaysAgo)
        setFilterByEndDate(currentDate)
        setFilterByCategory("0")
        setFilterByCategoryIds([])
        setFilterByLocationIds([])
        setFilterByUserIds([])
        setFilterByManager(0)
        setFilterByTimePeriod('')

        setLocalFilterByStartDate(sevenDaysAgo);
        setLocalFilterByEndDate(currentDate);
        setLocalFilterByCategory("0");
        setLocalFilterByCategoryIds([])
        setLocalFilterByLocationIds([])
        setLocalFilterByUserIds([])
        setLocalFilterByTimePeriod('')
        setSelectedCategoryIds([])
        setSelectedLocationIds([])
        setSelectedUserIds([])

    }
    const debouncedRefetch = debounce(() => {
        refetch().finally(() => {
            setIsApplyingFilters(false);
        });
    }, 300);
    useEffect(() => {
        if (isApplyingFilters) {
            debouncedRefetch();
        }
    }, [isApplyingFilters]);

    const handlePageSizeChange = (e: any) => {
        const newSize = parseInt(e.target.value);
        setPageSize(newSize);
        setPage(1); // Reset page number to 1
    };
    // pagination
    const handlePageClick = (e: any) => {
        setPage(e.selected + 1);
    };
    //per page record
    const handlePageRecords = (e: any) => {
        setPage(1); // Reset the page to 1
    };
    const handleSearchChange = (e: any) => {
        const { value } = e.target;
        setImmediateSearchStr(value); // Update immediate search state

        delayedSearch(value); // Update debounced search state
        setPage(1);
    };
    const delayedSearch = useCallback(
        debounce((searchValue) => {
            setSearchStr(searchValue);
        }, 500),
        []
    );
    useEffect(() => {
        refetch();
        if (searchStr === "") {
            refetch();
        }
    }, [searchStr]);
    const handleRefresh = () => {
        // Set the state values
        // setFilterByStartDate(sevenDaysAgo);
        // setFilterByEndDate(currentDate);
        // setLocalFilterByStartDate(sevenDaysAgo);
        // setLocalFilterByEndDate(currentDate);

        // Trigger refetch after state updates are done
        setTimeout(() => {
            refetch()
                .then(() => {
                    if (isSuccess) {
                        toast.success(tosterKey.dataRefreshedSuccesfully);
                    }
                });
        }, 0);
    };
    return (
        <>
            <div className='card ss-analytics-report-card' style={{ borderTopLeftRadius: 0, borderTopRightRadius: 0 }}>
                <div className='card-header border-0 align-items-center py-2'>
                    <div className="col-12">
                        <Alert variant="primary" className="mb-2 py-2">
                            <p className='mb-0 fs-7'>Displays all category budgets assigned to users, including allocated budget, utilized amount, remaining balance, and budget validity period. This page helps managers monitor budget consumption and track category-wise budget utilization for users based on the selected filters.</p>
                        </Alert>
                    </div>
                    <div className='d-flex align-items-center gap-2'>
                        <SearchBarComponent
                            placeholder='Category Budget'
                            value={immediateSearchStr}
                            onChange={handleSearchChange}
                        />
                        <RefreshComponent onClick={handleRefresh} />
                    </div>
                    {!showFilters ? (
                        <button
                            type="button"
                            className="btn btn-sm ss-pill-btn ss-pill-btn-filter-active"
                            onClick={() => setShowFilters(true)}
                        >
                            <i className="fa fa-filter me-1 text-white" />
                            Show Filters
                        </button>
                    ) : (
                        <button
                            type="button"
                            className="btn btn-sm ss-pill-btn ss-pill-btn-filter-active"
                            onClick={() => setShowFilters(false)}
                        >
                            <i className="fa fa-eye-slash me-1 text-white" />
                            Hide Filters
                        </button>
                    )}

                </div>
                <div className='card-body py-3'>
                    {showFilters && (
                        <div className="row border-bottom ss-report-filter-row" id='report_filters'>
                        <>
                            {/* <div className='col-md-4 col-lg-3 col-xl-2 mb-5'>
                                <div className='d-flex align-items-center justify-content-between'>
                                    <label className='form-label fs-6 fw-bold text-dark'>{labelKey.date}:</label>
                                    <div className='position-relative mb-2'>
                                        <label className='position-absolute text-primary'>Custom Date Range</label>
                                        <DateRangePicker onApply={handleDateRangeChange} onCancel={handleCancelDateSelection}>
                                            <input type="text"
                                                className='h-10px mw-100px opacity-0 cursor-pointer'
                                                value={localFilterByStartDate && localFilterByEndDate ? `${localFilterByStartDate} - ${localFilterByEndDate}` : "mm/dd/yyyy"} />
                                        </DateRangePicker>
                                    </div>
                                </div>
                                <Select
                                    // customLabelClick={() => setDateRangeHide(true)}
                                    options={[
                                        { value: 0, label: 'All' }, // Add the empty option
                                        ...(timePeriodOptions?.map((option: any) => ({
                                            value: option.id,
                                            label: option?.value,
                                        })))
                                    ]}
                                    placeholder={localFilterByStartDate && localFilterByEndDate ? `${localFilterByStartDate} - ${localFilterByEndDate}` : 'Select Date'}
                                    value={localFilterByTimePeriod && localFilterByTimePeriod !== ''
                                        ? {
                                            label: timePeriodOptions?.find((option: any) => option.id === localFilterByTimePeriod)?.value || '',
                                            value: localFilterByTimePeriod,
                                        }
                                        : null
                                    }
                                    onChange={handleTimePeriodChange}
                                />

                            </div> */}
                            <div className='col-md-4 col-lg-3 col-xl-2 mb-5'>
                                <DateRangeComp
                                    startDate={localFilterByStartDate}
                                    endDate={localFilterByEndDate}
                                    onApply={handleDateRangeChange}
                                    onCancel={handleCancelDateSelection}
                                    className='ss-filter-control'
                                    value={
                                        localFilterByStartDate && localFilterByEndDate
                                            ? `${localFilterByStartDate} - ${localFilterByEndDate}`
                                            : ''
                                    }
                                />
                            </div>
                            <div className='col-md-4 col-lg-3 col-xl-2 mb-5 ss-filter-col-categories'>
                                <label className='form-label fs-6 fw-bold'>{labelKey.category}:</label>
                                <Select
                                    isMulti
                                    options={categoryIdsOptions}
                                    closeMenuOnSelect={false}
                                    hideSelectedOptions={false}
                                    components={{ Option: CheckboxOption, MultiValue: CategoryMultiValue }}
                                    onChange={(selected) => handleCategoryIdsChange(selected as Option[])}
                                    value={selectedCategoryIds}
                                    placeholder='Search Category...'
                                    classNamePrefix='react-select'
                                    className='filter-valueContainer ss-users-multi-select ss-filter-control'
                                />
                            </div>
                            {!myReportpath && <>
                                {(roleID === constraintConfig.roleID.role4 && queryFeportPath) ||
                                    (roleID === constraintConfig.roleID.role10 && queryFeportPath) ||
                                    (roleID === constraintConfig.roleID.role2 && queryFeportPath) ? (
                                    <div className='col-md-4 col-lg-3 col-xl-2 mb-5'>
                                        <SearchSelect
                                            label={`${labelKey.manager}:`}
                                            options={[
                                                // { value: 0, label: 'All' }, // Add the empty option
                                                ...(Array.isArray(getAllManagers?.result) ? getAllManagers.result.map((option: any) => ({
                                                    value: option.id,
                                                    label: option?.value,
                                                })) : [])
                                            ]}
                                            placeholder='Select Manager...'
                                            value={filterByManager && filterByManager !== 0
                                                ? {
                                                    value: filterByManager,
                                                    label: getAllManagers?.result.find((option: any) => option.id === filterByManager)?.value
                                                }
                                                : null
                                            }
                                            onChange={handleManagerChange}
                                        />
                                    </div>
                                ) : null}
                                <div className='col-md-4 col-lg-3 col-xl-2 mb-5 ss-filter-col-users'>
                                    <label className='form-label fs-6 fw-bold'>{labelKey.users}:</label>
                                    <Select
                                        isMulti
                                        options={userIdsOptions}
                                        closeMenuOnSelect={false}
                                        hideSelectedOptions={false}
                                        components={{ Option: CheckboxOption, MultiValue: UsersMultiValue }}
                                        onChange={(selected) => handleUserIdsChange(selected as Option[])}
                                        value={selectedUserIds}
                                        placeholder='Search User...'
                                        classNamePrefix='react-select'
                                        className='filter-valueContainer ss-users-multi-select ss-filter-control'
                                    />
                                </div>
                            </>}
                            <div className='col-md-4 col-lg-3 col-xl-2 mb-5'>
                                <div className='d-flex align-items-end h-100 gap-3'>
                                    <button className='btn btn-danger pull-right me-3' onClick={resetFilters}>Reset Filters</button>

                                    <button className='btn btn-primary pull-right' onClick={applyFilters}>
                                        {isApplyingFilters ? <>
                                            <span>loading...</span>
                                            <Spinner as="span" animation="border" size="sm" role="status" aria-hidden="true" />
                                        </> : "Apply Filters"}
                                    </button>
                                </div>
                            </div>
                        </>
                    </div>
                    )}
                    <div className='table-responsive table-height'>
                        <table className='table table-row-dashed table-row-gray-300 align-middle gs-0 gy-4'>
                                    <thead>
                                        <tr className='fw-bold text-muted'>
                                            {hiddenColumns.includes('sr') && (
                                                <TableHeading
                                                    label={labelKey.sr}
                                                    columnId='sr'
                                                    className="ps-4 w-60px"
                                                />
                                            )}
                                            {hiddenColumns.includes('userName') && (
                                                <TableHeading
                                                    label={labelKey.userName}
                                                    columnId='userName'
                                                />
                                            )}
                                            {hiddenColumns.includes('budgetName') && (
                                                <TableHeading
                                                    label={labelKey.budgetName}
                                                    columnId='budgetName'
                                                />
                                            )}
                                            {hiddenColumns.includes('category') && (
                                                <TableHeading
                                                    label={labelKey.category}
                                                    columnId='category'
                                                    className="w-400px"
                                                />
                                            )}
                                            {hiddenColumns.includes('budget') && (
                                                <TableHeading
                                                    label={labelKey.budget}
                                                    columnId='budget'
                                                />
                                            )}
                                            {hiddenColumns.includes('remainingBudget') && (
                                                <TableHeading
                                                    label={labelKey.remainingBudget}
                                                    columnId='remainingBudget'
                                                />
                                            )}
                                            {hiddenColumns.includes('startDate') && (
                                                <TableHeading
                                                    label={labelKey.startDate}
                                                    columnId='startDate'
                                                />
                                            )}
                                            {hiddenColumns.includes('endDate') && (
                                                <TableHeading
                                                    label={labelKey.endDate}
                                                    columnId='endDate'
                                                />
                                            )}

                                            <TableHeading className='text-end rounded-end pe-2 border-0' columnId='menu'>
                                                <TableSettingMenu>
                                                    <TextField
                                                        rightLabel={labelKey.sr}
                                                        type="checkbox"
                                                        onChange={() => handleToggleColumn("sr")}
                                                        checked={hiddenColumns.includes('sr')}
                                                        fieldClass='mb-4'
                                                    />

                                                    <TextField
                                                        rightLabel={labelKey.userName}
                                                        type="checkbox"
                                                        onChange={() => handleToggleColumn("userName")}
                                                        checked={hiddenColumns.includes('userName')}
                                                        fieldClass='mb-4'
                                                    />
                                                    <TextField
                                                        rightLabel={labelKey.budgetName}
                                                        type="checkbox"
                                                        onChange={() => handleToggleColumn("budgetName")}
                                                        checked={hiddenColumns.includes('budgetName')}
                                                        fieldClass='mb-4'
                                                    />
                                                    <TextField
                                                        rightLabel={labelKey.category}
                                                        type="checkbox"
                                                        onChange={() => handleToggleColumn("category")}
                                                        checked={hiddenColumns.includes('category')}
                                                        fieldClass='mb-4'
                                                    />
                                                    <TextField
                                                        rightLabel={labelKey.budget}
                                                        type="checkbox"
                                                        onChange={() => handleToggleColumn("budget")}
                                                        checked={hiddenColumns.includes('budget')}
                                                        fieldClass='mb-4'
                                                    />
                                                    <TextField
                                                        rightLabel={labelKey.remainingBudget}
                                                        type="checkbox"
                                                        onChange={() => handleToggleColumn("remainingBudget")}
                                                        checked={hiddenColumns.includes('remainingBudget')}
                                                        fieldClass='mb-4'
                                                    />
                                                    <TextField
                                                        rightLabel={labelKey.startDate}
                                                        type="checkbox"
                                                        onChange={() => handleToggleColumn("startDate")}
                                                        checked={hiddenColumns.includes('startDate')}
                                                        fieldClass='mb-4'
                                                    />
                                                    <TextField
                                                        rightLabel={labelKey.endDate}
                                                        type="checkbox"
                                                        onChange={() => handleToggleColumn("endDate")}
                                                        checked={hiddenColumns.includes('endDate')}
                                                        fieldClass='mb-4'
                                                    />

                                                </TableSettingMenu>
                                            </TableHeading>

                                        </tr>
                                    </thead>
                                    <tbody>
                                        {!isLoading &&
                                            <>
                                                {data?.result?.data?.length > 0 ? (
                                                    <>
                                                        {data?.result?.data?.map((data: any, index: any) => (
                                                            <tr key={index}>
                                                                {hiddenColumns.includes('sr') && (
                                                                    <td className='text-center'>
                                                                        {(page - 1) * pageSize + index + 1}
                                                                    </td>
                                                                )}
                                                                {hiddenColumns.includes('userName') && (
                                                                    <td className='ps-5'>
                                                                        <div className="d-flex align-items-center">
                                                                            <div className="symbol symbol-circle symbol-50px overflow-hidden me-3">
                                                                                <div className="symbol-label fs-3 bg-light-info text-info text-capitalize">{data?.firstName.charAt(0)}</div>
                                                                            </div>
                                                                            <div className="d-flex flex-column">
                                                                                <p className="text-gray-800 fw-bold text-hover-primary mb-1 text-capitalize">{data?.firstName} {data?.lastName}</p>
                                                                                <span className='text-lowercase'>{data?.email}</span>
                                                                            </div>
                                                                        </div>
                                                                    </td>
                                                                )}
                                                                {hiddenColumns.includes('budgetName') && (
                                                                    <td>
                                                                        {data?.name}
                                                                    </td>
                                                                )}
                                                                {hiddenColumns.includes('category') && (
                                                                    <td>{data?.title}</td>
                                                                )}
                                                                {hiddenColumns.includes('budget') && (
                                                                    <td><CurrencyComp amount={data?.budget} /></td>
                                                                )}
                                                                {hiddenColumns.includes('remainingBudget') && (
                                                                    <td><CurrencyComp amount={data?.remainingBudget} /> </td>
                                                                )}
                                                                {hiddenColumns.includes('startDate') && (
                                                                    <td><DateTimeComp formattedDate={data?.startDate} /> </td>
                                                                )}
                                                                {hiddenColumns.includes('endDate') && (
                                                                    <td colSpan={2}><DateTimeComp formattedDate={data?.endDate} /></td>
                                                                )}
                                                            </tr>
                                                        ))}
                                                    </>
                                                ) :
                                                    (
                                                        <tr>
                                                            <td colSpan={10}>
                                                                <NoRecordFound />
                                                            </td>
                                                        </tr>
                                                    )
                                                }
                                            </>
                                        }
                                        {isLoading && (
                                            <tr>
                                                <td colSpan={10} className="text-center">
                                                    <LoadingComponent />
                                                </td>
                                            </tr>
                                        )}
                                    </tbody>
                                </table>
                            </div>
                    <Pagination
                        totalResult={data?.result?.totalRecords === 0 ? 0 : ((data?.result?.pageNumber - 1) * data?.result?.pageSize) + 1}
                        toResult={data?.result?.totalRecords === 0 ? 0 : Math.min(data?.result?.pageNumber * data?.result?.pageSize, data?.result?.totalRecords)}
                        ofResult={data?.result?.totalRecords}
                        onChange={handlePageSizeChange}
                        pageSize={pageSize}
                        onPageChange={handlePageClick}
                        pageCount={data?.result?.totalPages || 0}
                        currentPage={page}
                    />
                </div>
            </div>
        </>
    )
}

export default CategoryBudgetReport